export default {
    obtenerProcesosCliente(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerProcesosCliente`).then(response => {

            vm.procesos = response.data;

        })
    },



}